import { ButtonHTMLAttributes, Ref, forwardRef, memo } from 'react';

import { twMerge } from 'tailwind-merge';

export interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  open?: boolean;
  activeStateButtonClassname?: string;
}

const IconButton = (
  { open, className, children, activeStateButtonClassname, ...otherProps }: IconButtonProps,
  ref: Ref<HTMLButtonElement>,
) => {
  return (
    <button
      ref={ref}
      className={twMerge(
        'transition-colors duration-150 hover:bg-v2blueGray-100 text-v2blueGray-500 rounded-lg',
        open && 'bg-v2blueGray-100',
        activeStateButtonClassname && open ? activeStateButtonClassname : '',
        className,
      )}
      {...otherProps}
    >
      {children}
    </button>
  );
};
/**
 * @deprecated IconButton should not be used
 *
 * Use instead: `import { ActionIcon } from 'ui/atoms'
 */
export default memo(forwardRef(IconButton));
